import { Form, ModalForm } from 'components';
import { MediaUpload } from 'components/Form/inputs/MediaUpload/MediaUpload';
import { FormWrapper } from 'components/Modal/styles';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const MediaForm = ({
  onSubmit: handleSubmit,
  allowedMediaTypes = [{ 'image/*': [] }, { 'video/*': [] }],
  previewData,
}) => {
  const { t: appT } = useTranslation('app');
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpload = useCallback((acceptedFile) => {
    const uploadedFile = Object.assign(acceptedFile, {
      preview: URL.createObjectURL(acceptedFile),
    });
    setFile(uploadedFile);
  }, []);

  const onSubmit = async () => {
    if (!file) return;

    setIsSubmitting(true);
    try {
      await handleSubmit(file);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalForm
      initialValues={{ media: [] }}
      onSubmit={onSubmit}
      validateOnMount
      cancelLabel={appT('cancel')}
      submitLabel={appT('save').toUpperCase()}
      pristine
      isLoading={isSubmitting}
      isClosePopupOn={false}
      ignoreClickedState
    >
      <FormWrapper type="create">
        <Form.Group style={{ width: '100%' }}>
          <MediaUpload
            name="media"
            maxFiles={1}
            accept={allowedMediaTypes.map((type) => `${type}/*`)}
            withCrop
            withThumbnails
            onUpload={handleUpload}
            cropMediaType="look"
            previewData={previewData}
          />
        </Form.Group>
      </FormWrapper>
    </ModalForm>
  );
};

MediaForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  allowedMediaTypes: PropTypes.arrayOf(PropTypes.oneOf(['image', 'video'])),
  previewData: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    originImage: PropTypes.string,
  }),
};

export default MediaForm;
